<!-- نمایش تمام صفحه تصاویر -->

<section class="w-100 h-100">

    <div class="album-container">

        <img src="data:image/png;base64,{{lst_Album[albumIndex][strKey_list]}}" [@imageAnimation]="albumIndex">

        <ng-container *ngIf="lst_Album.length > 1">

            <div class="next-btn" (click)="updateIndex(true)" *ngIf="albumIndex != (lst_Album.length - 1)">

                <mat-icon>arrow_forward_ios</mat-icon>

            </div>

            <div class="prev-btn" (click)="updateIndex(false)" *ngIf="albumIndex > 0">

                <mat-icon>arrow_back_ios</mat-icon>

            </div>

        </ng-container>

    </div>

    <div class="thumbnail-container py-2">

        <ng-container *ngFor="let item of lst_Album;let i = index">

            <div *ngIf="lst_Album[i][strKey_list]" class="border border-1" (click)="albumIndex=i;download_Attachment(i)">

                <img src="data:image/png;base64,{{lst_Album[i][strKey_list]}}" [ngStyle]="{'opacity' : albumIndex == i ? '1' : '' }">

                <ng-container *ngIf="isDownloadAble && !item.isDownload">

                    <div class="download_image pointer">

                        <mat-icon class=""> downloading </mat-icon>

                    </div>

                </ng-container>
    
            </div>
            
        </ng-container>

    </div>

</section>